<template>
	<div>
		<div>
			<div
				class="AnswerAttemptsCount"
				v-if="totalAnswerAttemptsForQuestion > 0"
			>
				{{ totalAnswerAttemptsForQuestion }}
				{{
					t(
						"activerecord.models.answer_attempt." +
							(totalAnswerAttemptsForQuestion == 1 ? "one" : "other"),
					)
				}}
			</div>
			<div class="AnswerAttemptsCount" v-if="totalCommentsForQuestion > 0">
				{{ totalCommentsForQuestion }}
				{{
					t(
						"activerecord.models.comment." +
							(totalCommentsForQuestion == 1 ? "one" : "other"),
					)
				}}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
// Other components
import { i18n } from "../utils";

export default {
	mixins: [i18n],
	props: {
		questionId: Number,
		srvTotalCommentsForQuestion: Number,
		srvTotalAnswerAttemptsForQuestion: Number,
		questionType: Array,
	},
	data: function () {
		return {
			totalCommentsForQuestion: this.srvTotalCommentsForQuestion || 0,
			totalAnswerAttemptsForQuestion:
				this.srvTotalAnswerAttemptsForQuestion || 0,
		};
	},
	computed: {
		locale: function () {
			return I18n.locale;
		},
	},
	mounted() {
		// @ts-expect-error
		if (this.questionType.includes("commentable")) {
			pp.vue.bus.$on("question_comment-CREATE", this.onIncomingCommentable);
		}
		// @ts-expect-error
		if (this.questionType.includes("answerable")) {
			pp.vue.bus.$on("answer_attempt-CREATE", this.onIncomingAnswerAttempt);
		}
	},
	beforeDestroy() {
		pp.vue.bus.$off("question_comment-CREATE", this.onIncomingCommentable);
		pp.vue.bus.$off("answer_attempt-CREATE", this.onIncomingAnswerAttempt);
	},
	methods: {
		onIncomingAnswerAttempt(answerAttempt) {
			if (answerAttempt.answer_option.question_id != this.questionId) {
				return;
			}
			this.totalAnswerAttemptsForQuestion++;
		},
		onIncomingCommentable(commentable) {
			if (commentable.id != this.questionId) {
				return;
			}
			this.totalCommentsForQuestion++;
		},
	},
};
</script>
